import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["noAccessFallback"];
import { getPersonalizationAccess } from 'personalization-lib/utils/auth';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const withPersonalizationAccess = (WrappedComponent, {
  noAccessFallback
} = {}) => props => {
  const {
      noAccessFallback: propsFallback
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (!getPersonalizationAccess().view) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: propsFallback || noAccessFallback
    });
  }
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest));
};
export default withPersonalizationAccess;